export const GATEWAY_LOGS_RESET_STATE = 'GATEWAY_LOGS_RESET_STATE';
export const GATEWAY_LOGS_CURRENT_ITEM = 'GATEWAY_LOGS_CURRENT_ITEM';

export const GATEWAY_LOGS_REQUEST_LOADING = 'GATEWAY_LOGS_REQUEST_LOADING';
export const GATEWAY_LOGS_REQUEST_SUCCESS = 'GATEWAY_LOGS_REQUEST_SUCCESS';
export const GATEWAY_LOGS_REQUEST_FAILED = 'GATEWAY_LOGS_REQUEST_FAILED';

export const GATEWAY_LOGS_CURRENT_ACTION = 'GATEWAY_LOGS_CURRENT_ACTION';
export const GATEWAY_LOGS_RESET_ACTION = 'GATEWAY_LOGS_RESET_ACTION';